




















































































import {
  Vue,
  Component,
  Ref,
} from 'vue-property-decorator';

import { DataOptions } from 'vuetify';

import DDAConciliation from '@/domain/models/DDAConciliation';
import DDAConciliationRepository from '@/repositories/DDAConciliationRepository';
import IDDAConciliationFilter from '@/domain/interfaces/IDDAConciliationFilter';
import DDAConciliationMovement from '@/domain/models/DDAConciliationMovement';

import GroupFilterParametersEnum from '@/domain/enums/GroupFilterParametersEnum';
import ButtonExportCSV from '@/components/buttons/ButtonExportCSV.vue';
import FilterParametersRepository from '@/repositories/FilterParametersRepository';

import DdaConciliationFilter from './components/Filter.vue';
import DdaConciliationList from './components/List.vue';
import DDAConciliationListStatus from './components/ListStatus.vue';
import { formateErrorForNotification } from './utils';

@Component({
  components: {
    DdaConciliationFilter,
    DdaConciliationList,
    ButtonExportCSV,
  },
})
export default class DDDAConciliationPage extends Vue {
  @Ref('dda-conciliation-filter') ddaConciliationFilter!: DdaConciliationFilter;

  readonly DDAConciliationRepository:
    DDAConciliationRepository = new DDAConciliationRepository();

  readonly filterParametersRepository:
    FilterParametersRepository = new FilterParametersRepository();

  showFilter: boolean = true;
  showList: boolean = false;
  loading: boolean = false;

  sortBy: string = '';
  sortDesc: boolean = false;

  currentData: IDDAConciliationFilter = {} as IDDAConciliationFilter;

  list: Array<DDAConciliation> = [];

  get toggleIcon(): string {
    return this.showFilter ? 'mdi-chevron-up' : 'mdi-chevron-down';
  }

  get toggleTooltip(): string {
    return this.showFilter ? 'Ocultar Parâmetros' : 'Exibir Parâmetros';
  }

  get groupId(): number {
    return this.$session.get('company_group_id');
  }

  handleToggle(): void {
    this.showFilter = !this.showFilter;
  }

  handleGoToHistory(): void {
    this.$router.push({ path: 'conciliacoes-de-dda/historico' });
  }

  handleValidate(): void {
    this.ddaConciliationFilter.validate();
  }

  async handleLoad(data: IDDAConciliationFilter): Promise<void> {
    try {
      this.$dialog.startLoading();
      const {
        companies,
        initialDueDate,
        endDueDate,
        initialProcessingDate,
        endProcessingDate,
        status,
        suppliers,
        sort,
        allCompanies,
        paymentMethods,
      } = data;

      const parms = {
        initial_due_date: initialDueDate,
        end_due_date: endDueDate,
        initial_processing_date: initialProcessingDate,
        end_processing_date: endProcessingDate,
        status,
        suppliers,
        sort,
        payment_methods: paymentMethods,
      };

      if (parms.sort) this.sort(parms.sort);

      const items = await this.DDAConciliationRepository
        .getDDAConciliations(this.groupId, companies.length ? companies : allCompanies, parms);

      this.filterParametersRepository.setFilter(GroupFilterParametersEnum.DDA_CONCILIATION_LIST, [
        { key: 'initial_due_date_dda_conciliation_list', value: data.initialDueDate },
        { key: 'end_due_date_dda_conciliation_list', value: data.endDueDate },
        { key: 'initial_processing_date_dda_conciliation_list', value: data.initialProcessingDate },
        { key: 'end_processing_date_dda_conciliation_list', value: data.endProcessingDate },
        { key: 'companies_dda_conciliation_list', value: JSON.stringify(data.companies ?? []) },
        { key: 'status_dda_conciliation_list', value: JSON.stringify(data.status ?? []) },
        { key: 'sort_dda_conciliation_list', value: parms.sort },
        { key: 'payment_methods_dda_conciliation_list', value: JSON.stringify(data.paymentMethods ?? []) },
      ]);

      this.currentData = data;

      if (items.length) {
        this.list = items;
        this.showFilter = false;
        this.showList = true;
      } else {
        this.$notification.warn('Nenhuma conciliação de DDA foi encontrada! Por favor, tente novamente com outros parâmetros.');
        this.list = [];
        this.showFilter = true;
        this.showList = false;
      }
    } catch (error: any) {
      const errorMessage = formateErrorForNotification(error);
      this.$notification.error(errorMessage);
    } finally {
      this.$dialog.stopLoading();
    }
  }

  handleReload() {
    this.handleLoad(this.currentData);
  }

  updateSort(value: DataOptions) {
    const { sortBy, sortDesc } = value;
    this.sortBy = sortBy[0] || '';
    this.sortDesc = sortDesc[0] || false;
    if (!this.loading) this.handlerSort(this.sortBy, this.sortDesc);
  }

  sort(value: string): void {
    if (value.includes('-')) {
      this.sortBy = value.substring(1);
      this.sortDesc = true;
    } else {
      this.sortBy = value;
      this.sortDesc = false;
    }
  }

  handlerSort(by: string, desc: boolean): void {
    const params: IDDAConciliationFilter = {
      ...this.currentData,
    };

    const order = desc ? '-' : '';
    params.sort = by ? `${order}${by}` : undefined;

    this.handleLoad(params);
  }

  handleExport(): void {
    if (!this.list.length) {
      this.$notification.warn('Não há dados para exportar');
      return;
    }

    const headers = [
      { text: 'Status', value: 'status' },
      { text: 'Origem', value: 'origin' },
      { text: 'CNPJ', value: 'document' },
      { text: 'Razão Social', value: 'name' },
      { text: 'Título/Parc.', value: 'title' },
      { text: 'Valor', value: 'value' },
      { text: 'Emissão', value: 'emission_date' },
      { text: 'Vencimento', value: 'due_date' },
      { text: 'Cód. Barras', value: 'barcode' },
    ];

    const escape = (v: any) => {
      if (v === null || v === undefined) return '';
      const s = String(v).replace(/[;,]/g, '.');
      if (/["]|[\n\r]/.test(s)) {
        return `"${s.replace(/"/g, '""')}"`;
      }
      return s;
    };

    const { statusList } = new DDAConciliationListStatus();

    const csvHeaders = headers.map((header) => header.text).join(',');
    const csvRows = this.list.flatMap((item) => item.movements.map(
      (movement: DDAConciliationMovement) => headers.map((header) => {
            if (header.value === 'status') {
              const statusObject = statusList.find(
                (status) => status.code === item[header.value as keyof DDAConciliation],
              );
              return escape(statusObject?.text || '');
            }
            return escape(movement[header.value as keyof DDAConciliationMovement]);
          }).join(','),
      ));
    const csv = [csvHeaders, ...csvRows].join('\n');

    // Create and download the CSV file
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'conciliations-dda.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    this.$notification.success('Exportação iniciada');
  }
}
